import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { BubbleIcon } from '@/components/Icons/Bubble';
export const CustomIcon = ({ onClick, imgUrl, theme, size, ariaLabel, }) => {
    const [isBroken, setIsBroken] = useState(false);
    const handleKeyUp = useCallback((e) => {
        if (e.key === 'Enter') {
            onClick();
        }
    }, [onClick]);
    return !isBroken ? (_jsx("div", { className: 'h-12 max-h-18 w-12 max-w-18 cursor-pointer overflow-hidden rounded-full shadow-xl', onClick: onClick, onKeyUp: handleKeyUp, tabIndex: 0, "aria-label": ariaLabel, role: "button", style: { width: size, height: size }, children: _jsx("img", { src: imgUrl, alt: "custom icon", className: 'h-full w-full rounded-full object-cover', onError: () => setIsBroken(true) }) })) : (_jsx(BubbleIcon, { theme: theme, size: size, onClick: onClick }));
};
